export const HIT_PT_DEPARTEMENT = 'HIT_PT_DEPARTMENT';
export const GET_PT_DEPARTEMENT = 'GET_PT_DEPARTMENT';

export const HIT_PT_ADD_DEPARTEMENT = 'HIT_PT_ADD_DEPARTEMENT';
export const HIT_PT_DELETE_DEPARTEMENT = 'HIT_PT_DELETE_DEPARTEMENT';
export const HIT_PT_UPDATE_DEPARTEMENT = 'HIT_PT_ADDUPDATEPARTEMENT';

export const HIT_PT_ADD_DEPARTMENT_MEMBER = 'HIT_PT_ADD_DEPARTMENT_MEMBER';
